import { Controller } from "stimulus"

// Ticket 751: automatic rest timer with sticky bar.
// Rendered into #rest_timer_container when a set is completed. Auto-starts on connect,
// updates the remaining seconds + progress bar every second, and removes itself when the
// countdown finishes or the user taps "Overslaan" (skip). Only one instance exists at a
// time because the container is replaced on each new completion.
export default class extends Controller {
  static values = { seconds: Number, format: String }
  static targets = ["remaining", "bar"]

  connect() {
    this.total = this.secondsValue > 0 ? this.secondsValue : 90
    this.timeleft = this.total
    this.render()
    this.timer = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    this.clear()
  }

  tick() {
    this.timeleft -= 1
    if (this.timeleft <= 0) {
      this.render(0)
      this.finish()
      return
    }
    this.render()
  }

  render(value = this.timeleft) {
    if (this.hasRemainingTarget) {
      // Bugfix 32 (#1566): het nieuwe ontwerp toont de rusttijd als 1:45
      this.remainingTarget.textContent = this.formatValue === "mmss"
        ? `${Math.floor(value / 60)}:${String(value % 60).padStart(2, "0")}`
        : value
    }
    if (this.hasBarTarget) {
      const pct = Math.max(0, Math.min(100, (value / this.total) * 100))
      this.barTarget.style.width = `${pct}%`
    }
  }

  skip() {
    this.finish()
  }

  finish() {
    this.clear()
    // Remove the bar from the DOM so the next completion starts fresh.
    this.element.remove()
  }

  clear() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }
}
